import { SelectableObject } from './selectableObject';
import z from 'zod';

export const ColoredObjectSchema = SelectableObject.schema.extend({
  color: z.number().default(0xff00ff),
});
